"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRepetitionLabel = void 0;
const calcCustomRepetitionLabel_1 = __importDefault(require("@opsbase/lib-time/helpers/calcCustomRepetitionLabel"));
const shiftTZUTCToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZUTCToLocal"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
function CustomRepetitionLabel(props) {
    const utcDue = props.dueDate ? (0, shiftTZUTCToLocal_1.default)(props.dueDate) : undefined;
    return react_1.default.createElement(Text_1.default, null, (0, calcCustomRepetitionLabel_1.default)(utcDue, props.customRepetition));
}
exports.CustomRepetitionLabel = CustomRepetitionLabel;
exports.default = CustomRepetitionLabel;
